import { SVGProps } from "react";
import { fluid } from "~/styles/functions";
import * as styles from "./Border.css";
import clsx from "clsx";

interface Props extends SVGProps<SVGSVGElement> {}

const DrawnBorder = (props: Props) => (
  <svg
    // width={1920}
    height={6}
    preserveAspectRatio="xMinYMin slice"
    viewBox="0 0 1920 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"

    {...props}
    className={clsx(styles.border, props.className)}
  >
    <g>
      <path
        d="M0.195312 1.43455L25.7896 2.05455L51.3662 2.03455L76.9605 1.47455L102.555 1.98455L128.149 2.69455L153.743 1.45455L179.338 1.50455L204.914 2.55455L230.509 1.59455L256.103 1.98455L281.697 2.65455L307.291 1.16455L332.886 1.98455L358.48 2.76455L384.074 2.84455L409.669 2.72455L435.245 2.49455L460.84 1.46455L486.434 2.39455L512.028 2.42455L537.623 1.51455L563.199 1.34455L588.793 1.64455L614.388 1.86455L639.982 1.82455L665.559 1.81455L691.153 1.74455L716.747 1.37455L742.324 2.36455L767.918 1.84455L793.495 2.30455L819.089 1.30455L844.683 1.39455L870.278 1.94455L895.872 2.23455L921.466 2.27455L947.043 1.36455L972.637 1.20455L998.231 2.46455L1023.83 2.52455L1049.42 1.74455L1075.01 2.63455L1100.61 1.35455L1126.2 1.58455L1151.8 1.31455L1177.39 2.77455L1202.99 2.25455L1228.58 1.30455L1254.17 2.83455L1279.77 2.81455L1305.36 1.60455L1330.96 1.44455L1356.55 2.12455L1382.16 1.70455L1407.76 2.82455L1433.35 1.60455L1458.95 2.76455L1484.54 1.67455L1510.14 2.06455L1535.73 1.42455L1561.32 2.03455L1586.92 2.06455L1612.51 1.29455L1638.12 2.38455L1663.72 1.56455L1689.31 1.50455L1714.93 1.84455L1740.52 1.19455L1766.11 2.08455L1791.73 1.81455L1817.32 2.71455L1842.93 2.39455L1868.53 1.17455L1894.14 2.38455L1919.77 1.60455"
        stroke="inherit"

        strokeWidth={fluid("1.6")}
        // strokeWidth={1.6}
        strokeMiterlimit={10}
      />
    </g>
  </svg>
);

export default DrawnBorder;
